/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Statep11Inputs */



/**
* | output |
* | --- |
* | "Left/high pump state" |
*
* @param {Br_History_Key_Statep11Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_statep11 = /** @type {((inputs?: Br_History_Key_Statep11Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Statep11Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/high pump state")
	return /** @type {LocalizedString} */ ("Etat pompe gauche/haute")
});
export { br_history_key_statep11 as "br_history_key_stateP1" }